/**
 * @param {number|string} number
 *
 * @return {string}
 */
export function formatNumber( number = 0 ) {
    return new Intl.NumberFormat().format( number );
}
